/* eslint-disable arrow-body-style */

import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

// Custom
import UserContext from "@/components/UserContext/UserContext";
import modelIzlet from "@/models/izlet";
import modelIzletVodicSudionik from "@/models/izlet_vodic_sudionik";
import DataCentricPage from "@/views/DataCentric/DataCentricPage";
import HPSIzletForm from "./Forms/HPSIzletForm";
import { Permissions } from "@/lib/permissions";


const VodicIzletiPage = () => {
  const { t } = useTranslation();
  const userContext = useContext(UserContext);

  const canEdit = userContext?.hasAnyPermission([Permissions.HPSPlanVodicEdit]);

  return (
    <DataCentricPage
      needPermission={[Permissions.HPSPlanVodicEdit, Permissions.HPSPlanVodicView]}

      primaryModel={modelIzlet}
      primaryTitleToken="titles.izleti_moji"
      primaryView="vodic"
      primaryAllowAdd={canEdit}
      primaryAddLabel={t('titles.izlet_new') as string}
      primaryDialogInsertForm="vodic"
      primaryAllowView
      primaryDialogForm="vodic"
      primaryDialogComponent={HPSIzletForm}
      primaryAllowEdit={canEdit}
      primaryCanEditRecordAttribute='can_edit'
      primaryAllowGeneratePDF
      primaryAllowShareIzlet
      primaryAllowGenerateVodickiObrazac
      primaryOverrideAPIUrl="hps/izleti?type=vodic"
      primaryExportLabel="buttons.export_xlsx_izleti"

      secondaryModel={modelIzletVodicSudionik}
      secondaryTitleToken="titles.vodici_sudionici"
      secondaryView="vodic"
      secondaryAllowView={false}
      
      baseRecordPath={modelIzlet.apiPath}
      childRecordRelativePath="vodici-i-sudionici"
      geomRelativePath="geom"
      miniMapBaseRecordQueryParams="?type=vodic"
      
      mapId={10}
      mapModel={modelIzlet}
    />
  )
};

export default VodicIzletiPage;
